<template>
  <div class="popup-container">
    <div :id="popup.id" class="simple-popup magic-popup mfp-hide">
      <div class="popup-content">
        <h3 v-if="popup.title" v-html="popup.title"></h3>
          <div class="kr-embedded">
              <p>La procédure de paiement va commencer; Confirmer pour continuer</p>
              <div v-html="form"></div>
              <button @click="beforePayment()">Confirmer</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { registrationHelpers } from '../../main'

export default {
  name: 'payment-popup',
  props: ['popup'],
  data() {
    return {
      form: '',
    }
  },
  methods: {
    showFields() {
      $("input[name='vads_action_mode']").attr('type', '')
      $("input[name='vads_amount']").attr('type', '')
      $("input[name='vads_ctx_mode']").attr('type', '')
      $("input[name='vads_currency']").attr('type', '')
      $("input[name='vads_language']").attr('type', '')
      $("input[name='vads_page_action']").attr('type', '')
      $("input[name='vads_payment_config']").attr('type', '')
      $("input[name='vads_site_id']").attr('type', '')
      $("input[name='vads_trans_date']").attr('type', '')
      $("input[name='vads_trans_id']").attr('type', '')
      $("input[name='vads_vads_version']").attr('type', '')
      $("input[name='signature']").attr('type', '')
    },
    getForm() {
      this.$http.get(window.location.origin + '/api/generateForm/' + this.$route.query.abonnement)
        .then(response => {
          this.form = [response.data.form.slice(0, 5), ' name="paymentForm" ', response.data.form.slice(5)].join('')
        })
        .catch(error => {
          this.error = error
          console.log(error)
          this.loading = false
          setTimeout(function () {
            this.submitting = false
            //
          }, 2000)
        })
    },
    beforePayment() {
      this.$http.get(window.location.origin + '/api/beforePayment')
        .then(response => {
          $("form[name='paymentForm']").submit()
        })
        .catch(error => {
          this.error = error
          console.log(error)
          this.loading = false
          setTimeout(function () {
            this.submitting = false
            //
          }, 2000)
        })
    },
  },
  created: function () {
  },
  updated: function () {
    this.$nextTick(function () {
      // this.showFields()
    })
  },
  mounted: function () {
    this.getForm()

    $.extend(true, $.magnificPopup.defaults, {
      tClose: 'Fermer (Esc)',
      tLoading: 'Chargement...',
      image: {
        tError: '<a href="%url%">L\'image</a> n\'a pu être chargée.', // Error message when image could not be loaded
      },
      ajax: {
        tError: '<a href="%url%">Le contenu</a> ne peut-être chargé.<br><a href="%url%">Cliquez-ici</a>', // Error message when ajax request failed
      },
    })
    const hauteurFenetre = document.documentElement.clientHeight
    const hauteurPopup = hauteurFenetre - 40
    $('.popup-trigger').magnificPopup({
      type: 'inline',
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: 'auto',
      mainClass: 'mfp-fade',
      callbacks: {
        open: function () {
          console.log('e')
          $('.scroller').scrollbar({
            showArrows: true,
          })
        },
        resize: function () {
          const hauteurFenetre = document.documentElement.clientHeight
          const hauteurPopup = hauteurFenetre - 40
          const hauteurTitre = $('.container-content-popup h1').height()
          const hauteurContainerTexte = (hauteurPopup - hauteurTitre) - 98// padding container + padding-bottom;

          $('.container-content-popup > div').css('height', hauteurContainerTexte)
          $('.container-content-popup').css('height', hauteurPopup)
        },
      },
    })
  },
}
</script>
